/** Mirrors the backend DebitAttemptStatusContract (serialized as PascalCase strings). */
export enum DebitAttemptStatus {
  Processing = "Processing",
  Succeeded = "Succeeded",
  Failed = "Failed",
  /** The card's bank asks the member to confirm the charge; a pay link is out (PD-0043). */
  NeedsMember = "NeedsMember",
}
